import { render, staticRenderFns } from "./EventAdminSms.vue?vue&type=template&id=596e31e9"
import script from "./EventAdminSms.vue?vue&type=script&lang=js"
export * from "./EventAdminSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports